import * as React from 'react';
import ReactGA from 'react-ga';
import styled from 'styled-components';

type SocialButtonProps = {
    buttonID?: string;
    name: string;
    source: string;
    onClick?: () => void;
};

export const SocialButton: React.FC<SocialButtonProps> = ({ buttonID = '', name, source, onClick }) => (
    <SocialContainer
        id={buttonID}
        onClick={onClick}
    >
        <SocialImage
            src={source}
        />
    </SocialContainer>
);

export default SocialButton;

const SocialContainer = styled.div`
    float: left;
`;
const SocialImage = styled.img`
      width: 50px;
      height: 50px;
      padding: 15px 10px 16px;
      cursor: pointer;
`;
